export enum ClientTypeEnum {
  INDIVIDUAL = 'Individual',
  FACILITY = 'Facility',
  GOVERNMENTAL = 'Governmental Facility',
}

export enum ClientGenderEnum {
  MALE = 'male',
  FEMALE = 'female',
}

export interface ClientAddress {
  street: string;
  district: string;
  city: string;
  buildingNumber: string;
  postalCode: string;
  unitNumber?: string | null;
  additionalNumber?: string | null;
}

export interface ClientContact {
  id?: number;
  name: string;
  phone: string;
  email?: string | null;
}

export enum ClientVerificationStatusEnum {
  PENDING = 'pending',
  WATHQ_VERIFIED = 'wathq_verified',
  ADMIN_VERIFIED = 'admin_verified',
  REJECTED = 'rejected',
}

export interface Client {
  id: number;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: number;
  name: string;
  nameAr?: string;
  email: string;
  phone?: string;
  notes?: string | null;
  isActive: boolean;
  emailVerified?: boolean;
  isVIB: boolean;
  isVerified?: boolean;
  verified?: boolean;
  verificationStatus?: ClientVerificationStatusEnum;
  type: ClientTypeEnum;
  gender?: ClientGenderEnum;
  nationalOrResidencyId?: string;
  taxNumber?: string;
  crNationalNumber?: string;
  commercialRegistrationNumber?: string;
  address?: ClientAddress;
  contacts?: ClientContact[];
}

export interface ClientFormValue {
  organizationName: string;
  phone: string;
  email: string;
  password: string;
  type: ClientTypeEnum;
  isVIB?: boolean;
  approveOnCreate?: boolean;
  notes?: string | null;
  gender?: ClientGenderEnum;
  nationalOrResidencyId?: string;
  taxRegistrationNumber?: string;
  commercialRegistrationNumber?: string;
  crNationalNumber?: string;
  wathqVerificationToken?: string;
  adminVerify?: boolean;
  address?: ClientAddress;
  contacts?: ClientContact[];
}

export type CreateClientDto = ClientFormValue;

export type UpdateClientDto = Omit<
  Partial<ClientFormValue>,
  'type' | 'password'
>;

export type RegisterClientDto = ClientFormValue & {tenantId: number};
